const GENERATION_TYPES = {
  joint: 'joint copyright',
  customer: 'customer copyright',
};

module.exports = GENERATION_TYPES;
